import { useEffect, useReducer } from 'react';
import 'swiper/css';
import CustomCalendar from '../../../components/TestScheduler/CustomCalendar';
import {
    SchedulerData,
    ViewType,
    // DemoData,
    wrapperFun
} from './react-big-schedule';
import './react-big-schedule/dist/css/style.css';

const initialState = {
    showScheduler: false,
    viewModel: {},
};

function reducer(state, action) {
    switch (action.type) {
        case 'INITIALIZE':
            return { showScheduler: true, viewModel: action.payload };
        case 'UPDATE_SCHEDULER':
            return { ...state, viewModel: action.payload };
        default:
            return state;
    }
}

function App({
    events,
    resources,
    currentSchedulerState,
    currentConfigOfScheduler,
    setCurrentConfigOfScheduler,
    tabKey,
    paginationMetadata,
    onLoadMore,
    isLoadingMore,
    onResourceClick, itsAllowDrag = true,
    shiftTypeHandler,
    onViewChange,
    onDateChange,
}) {
    let schedulerData;

    const [state, dispatch] = useReducer(reducer, initialState);


    useEffect(() => {
        schedulerData = new SchedulerData(
            currentConfigOfScheduler?.date,
            currentConfigOfScheduler?.viewType,
            false,
            false,
            {
                views: [
                    {
                        viewName: 'Day',
                        viewType: ViewType.Day,
                        showAgenda: false,
                        isEventPerspective: false,
                    },
                    {
                        viewName: 'Week',
                        viewType: ViewType.Week,
                        showAgenda: false,
                        isEventPerspective: false,
                    },
                ],
            },
        );
        schedulerData.localeDayjs.locale('en');
        schedulerData.setResources(resources);
        schedulerData.setEvents(events);
        schedulerData.currentSchedulerState = currentSchedulerState;
        schedulerData.config.minuteStep = 30;
        schedulerData.config.eventItemHeight = 30; // Increased from default 28
        schedulerData.config.eventItemLineHeight = 30; // Increased from default 20
        dispatch({ type: 'INITIALIZE', payload: schedulerData });
    }, [resources, events, currentConfigOfScheduler]);

    console.log(state, 'state.showScheduler ');
    return (
        <>
            {state.showScheduler && (
                <div className="w-full" style={{ width: '100%' }}>
                    <CustomCalendar
                        itsAllowDrag={itsAllowDrag}
                        schedulerData={state.viewModel}
                        tabKey={tabKey}
                        paginationMetadata={paginationMetadata}
                        onLoadMore={onLoadMore}
                        isLoadingMore={isLoadingMore}
                        onResourceClick={onResourceClick}
                        shiftTypeHandler={shiftTypeHandler}
                        onViewChange={onViewChange}
                        onDateChange={onDateChange}
                    />
                </div>
            )}
        </>
    );
}

export default wrapperFun(App);

